


export type SubZulipChannelStatus = 'NoAccount' | 'AccountNotActive' | 'AccountActive';

export const SubZulipChannelStatus = {
    NoAccount: 'NoAccount' as SubZulipChannelStatus,
    AccountNotActive: 'AccountNotActive' as SubZulipChannelStatus,
    AccountActive: 'AccountActive' as SubZulipChannelStatus
};

